import React, {useEffect} from 'react';

import {ProactForm, ProactFormGrid} from 'src/app/forms/engine/ProactForm';
import {useProactForm} from 'src/app/forms/engine/useProactForm';
import {FormViewComponentV2} from 'src/app/forms/FormViewComponent/FormViewComponentV2';
import type {IFormDataV2} from 'src/types/FormV2';
import {QuizFormMeta} from '../../../../../app/training/courseFormMeta';

export interface QuizFormProps {
  data: IFormDataV2;
  mode: 'edit' | 'view';
  onFormDataChange?: (data: IFormDataV2) => void;
}
export const QuizForm: React.FC<QuizFormProps> = ({
  data,
  mode,
  onFormDataChange,
}) => {
  const form = useProactForm({formMeta: QuizFormMeta, initialData: data});
  const {methods, validateForm} = form;

  useEffect(() => {
    if (mode !== 'edit') {
      return;
    }
    void validateForm();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mode]);

  useEffect(() => {
    if (mode !== 'edit') {
      return;
    }
    const subscription = methods.watch((values, {name}) => {
      if (!name) {
        return;
      }
      onFormDataChange?.({...values});
      void validateForm();
    });
    return () => subscription.unsubscribe();
  }, [mode, methods, onFormDataChange, validateForm]);

  return mode === 'edit' ? (
    <ProactForm form={form}>
      <ProactFormGrid />
    </ProactForm>
  ) : (
    <FormViewComponentV2 formData={data} formMeta={QuizFormMeta} />
  );
};
